// extracted by mini-css-extract-plugin
var _1 = "w_wZOaZJZdr069YoSMjq";
var _2 = "JojGbZLbpyRhRPQgXa3y";
export { _1 as "root", _2 as "row" }
